import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-white font-heading font-semibold text-lg mb-4">JavBus 使用指南</h4>
              <p className="text-background-400 text-sm leading-relaxed">
                致力于为中文用户提供 JavBus 影片资料库平台的完整使用指南，涵盖最新访问入口、搜索技巧、使用教程及常见问题解答。
              </p>
            </div>

            <div>
              <h4 className="text-white font-heading font-semibold text-sm mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/latest-address" className="text-background-400 hover:text-white text-sm transition-colors">最新地址</Link>
                </li>
                <li>
                  <Link to="/category/search-tips" className="text-background-400 hover:text-white text-sm transition-colors">搜索技巧</Link>
                </li>
                <li>
                  <Link to="/category/usage-tutorial" className="text-background-400 hover:text-white text-sm transition-colors">使用教程</Link>
                </li>
                <li>
                  <Link to="/category/mirror-sites" className="text-background-400 hover:text-white text-sm transition-colors">镜像站点</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-heading font-semibold text-sm mb-4">热门文章</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/article/javbus-latest-address-2026" className="text-background-400 hover:text-white text-sm transition-colors">JavBus 最新地址 2026</Link>
                </li>
                <li>
                  <Link to="/article/javbus-search-number-guide" className="text-background-400 hover:text-white text-sm transition-colors">番号查询完整教程</Link>
                </li>
                <li>
                  <Link to="/article/javbus-beginner-tutorial" className="text-background-400 hover:text-white text-sm transition-colors">新手入门完全教程</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-heading font-semibold text-sm mb-4">关于本站</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-background-400 hover:text-white text-sm transition-colors">关于我们</Link>
                </li>
                <li>
                  <Link to="/about#contact" className="text-background-400 hover:text-white text-sm transition-colors">联系我们</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {currentYear} JavBus 使用指南. 本站为信息导航站点，与 JavBus 官方无关。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-white text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-white text-xs transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}